import { ScanText, Github, Twitter, Linkedin } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Button } from './ui/button';

const staticLinks = {
  Product: ['Features', 'How it Works', 'Pricing', 'API Docs'],
  Resources: ['Documentation', 'API Reference', 'Dashboard'],
  Company: ['About', 'Contact'],
};

const legalLinks = [
  { label: 'Privacy Policy', href: '/privacy' },
  { label: 'Terms of Service', href: '/terms' },
];

export default function Footer({ onGetStarted, onSignIn }) {
  return (
    <footer className='bg-card border-t border-border'>
      <div className='max-w-7xl mx-auto px-4 sm:px-6 lg:px-8'>
        {/* Top */}
        <div className='py-14 grid sm:grid-cols-2 lg:grid-cols-6 gap-10'>
          {/* Brand */}
          <div className='lg:col-span-2'>
            <div className='flex items-center gap-2 mb-4'>
              <div className='w-8 h-8 rounded-lg bg-primary flex items-center justify-center'>
                <ScanText className='w-4.5 h-4.5 text-primary-foreground' strokeWidth={2.2} />
              </div>
              <span className='font-heading font-bold text-lg text-foreground'>
                Invoice<span className='text-primary'>Reader</span>
              </span>
            </div>
            <p className='text-sm text-muted-foreground leading-relaxed max-w-xs mb-6'>
              Invoice field extraction API. Fully offline, privacy-first. No cloud AI, no data stored.
            </p>
            <div className='flex gap-3'>
              {[Twitter, Github, Linkedin].map((Icon, i) => (
                <button
                  key={i}
                  className='w-9 h-9 rounded-lg border border-border flex items-center justify-center text-muted-foreground hover:text-foreground hover:border-primary/40 transition-colors duration-200'
                >
                  <Icon className='w-4 h-4' />
                </button>
              ))}
            </div>
          </div>

          {/* Links */}
          {Object.entries(staticLinks).map(([section, items]) => (
            <div key={section}>
              <h4 className='font-heading font-semibold text-sm text-foreground mb-4 tracking-wide'>{section}</h4>
              <ul className='space-y-2.5'>
                {items.map((item) => (
                  <li key={item}>
                    <button className='text-sm text-muted-foreground hover:text-foreground transition-colors duration-150'>
                      {item}
                    </button>
                  </li>
                ))}
              </ul>
            </div>
          ))}
          <div>
            <h4 className='font-heading font-semibold text-sm text-foreground mb-4 tracking-wide'>Legal</h4>
            <ul className='space-y-2.5'>
              {legalLinks.map(({ label, href }) => (
                <li key={label}>
                  <Link to={href} className='text-sm text-muted-foreground hover:text-foreground transition-colors duration-150'>
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className='py-6 border-t border-border flex flex-col sm:flex-row items-center justify-between gap-4'>
          <p className='text-xs text-muted-foreground'>
            &copy; {new Date().getFullYear()} Tyo Solution. All rights reserved.
          </p>
          <div className='flex items-center gap-4'>
            <Button variant='ghost' size='sm' className='text-xs text-muted-foreground' onClick={onSignIn}>Sign In</Button>
            <Button variant='soft' size='sm' className='text-xs' onClick={onGetStarted}>Get Started Free</Button>
          </div>
        </div>
      </div>
    </footer>
  );
}
